<template>
  <div class="menu-container">
    <div class="flex user-info">
        <img src="/static/images/logo.png" class="logo-img" alt="">
    </div>
      <!--<div class="collapse-container" @click="collapseMenu" >-->
        <!--<img src="/static/icons/shouqi.png" style="width: 20px; height: 20px;" v-if="!isCollapse" alt="">-->
         <!--<span class="font-14-ff ml-12 flex-1" v-if="!isCollapse">点击收起菜单</span>-->
        <!--<img src="/static/icons/zhankai.png" style="width: 20px; height: 20px;" v-else alt="">-->
      <!--</div>-->
    <el-scrollbar style="flex: 1">
      <div class="h-100">
        <el-menu class="el-menu-vertical-demo" default-active="1" unique-opened>
          <template v-for="(item, index) in menuList">
            <el-submenu :key="index" :index="(index + 1) + ''" v-if="item.child && item.child.length && (!item.permission || permissionIn(item.permission))">
              <div slot="title" class="no-child">
                <img :src="'/static/images/' + item.img + '.png'" class="default-menu-img menu-img" alt="">
                <img :src="'/static/images/' + item.img + 'xz.png'" class="active-menu-img menu-img" alt="">
                <span slot="title">{{item.name}}</span>
              </div>
              <el-menu-item v-for="(child, idx) in item.child" :key="idx" :index="(index + 1) + '-' + (idx+1)" v-if="!child.permission || permissionIn(child.permission)" @click="toPage(child.path)">
                <span slot="title">{{child.name}}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :key="index" class="no-child" :index="(index + 1) + ''" v-else-if="!item.permission || permissionIn(item.permission)" @click="toPage(item.path)">
              <img :src="'/static/images/' + item.img + '.png'" class="default-menu-img menu-img" alt="">
              <img :src="'/static/images/' + item.img + 'xz.png'" class="active-menu-img menu-img" alt="">
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  components: {},
  data () {
    return {
      menu: this.$store.state.menu || '',
      isCollapse: false,
      menuList: [
        {
          img: 'shouye',
          path: '/welcome/index',
          name: '首页'
        },
        // {
        //   img: 'shouye',
        //   name: '示范页',
        //   child: [{
        //     name: '示范页1',
        //     path: '/welcome2/index'
        //   }, {
        //     name: '示范页2',
        //     path: '/welcome2/index01'
        //   }, {
        //     name: '报表',
        //     path: '/report/demo'
        //   }]
        // },
        {
          img: 'kehuguanli',
          name: '客户管理',
          permission: 'customerManage',
          child: [{
            name: '储备客户',
            path: '/customer/reserveCustomer',
            permission: 'reserveCustomer'
          }, {
            name: '上门客户',
            path: '/customer/doorCustomer',
            permission: 'doorCustomer'
          }, {
            name: '概算合同',
            path: '/customer/budgetContract',
            permission: 'budgetContract'
          }, {
            name: '预算审核',
            path: '/customer/budgetExamine',
            permission: 'budgetExamine'
          }, {
            name: '施工合同',
            path: '/customer/constructionContract',
            permission: 'constructionContract'
          }, {
            name: '工程管理',
            path: '/customer/projectManager',
            permission: 'projectManager'
          }, {
            name: '售后服务',
            path: '/customer/afterSales',
            permission: 'afterSales'
          }, {
            name: '飞单客户',
            path: '/customer/flyOrder',
            permission: 'flyOrder'
          }, {
            name: '全部客户',
            path: '/customer/all',
            permission: 'all'
          }]
        },
        {
          img: 'caiwuguanli',
          name: '财务管理',
          permission: 'financeManage',
          child: [
            {
              name: '待记账工程款',
              path: '/financeManage/recordedProjectFund',
              permission: 'recordedProjectFund'
            },
            {
              name: '在建工程明细',
              path: '/financeManage/projectDetailedAccount',
              permission: 'projectDetailedAccount'
            },
            {
              name: '付材料采购款',
              path: '/financeManage/purchaseMaterialPayment',
              permission: 'purchaseMaterialPayment'
            },
            {
              name: '出纳流水账',
              path: '/financeManage/cashierFlowAccount',
              permission: 'cashierFlowAccount'
            }
          ]
        },
        {
          img: 'xingzhengguanli',
          name: '行政管理',
          permission: 'administrativeManagement',
          child: [{
            name: '公司人员定义',
            path: '/administrative/employeeDefine',
            permission: 'employeeDefine'
          }, {
            name: '公司公告发布',
            path: '/administrative/announcement',
            permission: 'announcement'
          }]
        },
        {
          img: 'dingdanguanli',
          name: '订单管理',
          permission: 'orderManage',
          child: [{
            name: '材料入库单',
            path: '/order/materialIn',
            permission: 'materialInputOrder'
          }, {
            name: '材料入库退单',
            path: '/order/materialInReturned',
            permission: 'materialInputReturnedOrder'
          }, {
            name: '材料出库单',
            path: '/order/materialOut',
            permission: 'materialOutputOrder'
          }, {
            name: '材料出库退料单',
            path: '/order/materialOutReturned',
            permission: 'materialOutputReturnedOrder'
          }, {
            name: '库存报损单',
            path: '/order/reportLoss',
            permission: 'reportLossOrder'
          }, {
            name: '库存报溢单',
            path: '/order/reportOverflow',
            permission: 'reportOverflowOrder'
          }, {
            name: '辅材调拨单',
            path: '/order/auxiliaryMaterials',
            permission: 'auxiliaryMaterialsOrder'
          }, {
            name: '辅材调拨退料单',
            path: '/order/auxiliaryMaterialsReturned',
            permission: 'auxiliaryMaterialsReturnedOrder'
          }, {
            name: '主材调拨单',
            path: '/order/mainMaterials',
            permission: 'mainMaterialsOrder'
          }, {
            name: '主材调拨退料单',
            path: '/order/mainMaterialsReturned',
            permission: 'mainMaterialsReturnedOrder'
          }, {
            name: '软装调拨单',
            path: '/order/softMaterials',
            permission: 'softMaterialsOrder'
          }, {
            name: '软装调拨退料单',
            path: '/order/softMaterialsReturned',
            permission: 'softMaterialsReturnedOrder'
          }, {
            name: '主材补货单',
            path: '/order/mainMaterialsReplenishment',
            permission: 'mainMaterialsReplenishmentOrder'
          }, {
            name: '库存台账',
            path: '/order/inventoryStock',
            permission: 'stock'
          }]
        },
        {
          img: 'dingechaxun',
          path: '/quotaSearch/index',
          name: '定额查询',
          permission: 'quotaSearch'
        },
        {
          img: 'cailiaochaxun',
          path: '/materialSearch/index',
          name: '材料查询',
          permission: 'materialSearch'
        },
        {
          img: 'chenggonganli',
          path: '/successfulCases/index',
          name: '成功案例',
          permission: 'successfulCases'
        },
        {
          img: 'xitongdingyi',
          name: '系统定义',
          permission: 'systemDefine',
          child: [{
            name: '基础信息定义',
            path: '/systemDefine/basicDefine',
            permission: 'basicDefine'
          }, {
            name: '工程进度计划定义',
            path: '/systemDefine/projectProgressDefine',
            permission: 'projectProgressDefine'
          }, {
            name: '供应商定义',
            path: '/systemDefine/businessDefine',
            permission: 'businessDefine'
          }, {
            name: '材料及价格定义',
            path: '/systemDefine/materialDefine',
            permission: 'materialDefine'
          }, {
            name: '房间包含定义',
            path: '/systemDefine/roomBagDefine',
            permission: 'budgetPackageDefine'
          }, {
            name: '报价模板定义',
            path: '/systemDefine/quotationTemplateDefine',
            permission: 'budgetTemplateDefine'
          }, {
            name: '部门指派定义',
            path: '/systemDefine/departmentAssignDefine',
            permission: 'departmentAssignDefine'
          }, {
            name: '工程定额定义',
            path: '/systemDefine/quotaDefine',
            permission: 'projectQuotaDefine'
          }, {
            name: '单据定义',
            path: '/systemDefine/materialOrderDefine',
            permission: 'materialOrderDefine'
          }, {
            name: '客户界面定义',
            path: '/systemDefine/customerViewDefine',
            permission: 'customerViewDefine'
          }, {
            name: '岗位权限定义',
            path: '/systemDefine/stationDefine',
            permission: 'stationDefine'
          }, {
            name: '收款通知单定义',
            path: '/systemDefine/receivablesDefine',
            permission: 'receivablesDefine'
          }, {
            name: '付款通知单定义',
            path: '/systemDefine/paymentDefine',
            permission: 'paymentDefine'
          }, {
            name: '项目提成定义',
            path: '/systemDefine/percentageDefine',
            permission: 'percentageDefine'
          }, {
            name: '仓库定义',
            path: '/systemDefine/warehouseDefine',
            permission: 'warehouseDefine'
          }, {
            name: '库存过账期间定义',
            path: '/systemDefine/inventoryPeriodrDefine',
            permission: 'inventoryPeriodrDefine'
          }, {
            name: '期初库存台账',
            path: '/systemDefine/startInventoryDefine',
            permission: 'startInventoryDefine'
          }, {
            name: '银行账户定义',
            path: '/systemDefine/bankAccountDefine',
            permission: 'bankAccountDefine'
          }, {
            name: '公司定义',
            path: '/systemDefine/companyDefine',
            permission: 'companyDefine'
          }, {
            name: '报表定义',
            path: '/systemDefine/reportDefine',
            permission: 'reportDefine'
          }]
        },
        {
          img: 'juecezhongxin',
          path: '/decisionCenter/index',
          name: '决策中心',
          permission: 'decisionCenter'
        }
      ]
    }
  },
  created () {
    // if (!this.menu) {
    this.axios.post(`${this.$store.state.API_URL_9010}/permission/menuStr`).then(res => {
      this.menu = res.data.data
      this.$store.dispatch('setMenu', res.data.data)
    })
    // }
  },
  activated () {
  },
  mounted () {
  },
  methods: {
    toPage: function (path) {
      if (this.$route.fullPath !== path) {
        this.$router.replace(path)
      }
    },
    collapseMenu: function () {
      this.isCollapse = !this.isCollapse
    },
    permissionIn: function (permission) {
      return this.menu.indexOf(permission) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-menu-vertical-demo {
    height: 100%;
    border-right: none;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
  }

  .menu-container {
    height: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    z-index: 9;
    display: flex;
    flex-direction: column;
  }
  .el-menu-item:focus, .el-menu-item:hover {
    background-color: transparent;
    cursor: pointer;
  }

  .no-child {
    text-align: left;
    height: 40px;
    border-bottom: 1px dashed #e2e2e2;
    display: flex;
    align-items: center;
    color: #30313a;
    font-size: 16px;
    font-weight: bold;
    .active-menu-img {
      display: none;
    }
    &.is-active {
      background-color: #f5971d;
      color: #ffffff;
      .active-menu-img {
        display: block;
      }
      .default-menu-img {
        display: none;
      }
    }
    span {
      line-height: 28px;
    }
    .menu-img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }

  .collapse-container {
    height: 44px;
    background: #BAB5B1;
    padding: 12px;
    display: flex;
    text-align: left;
    cursor: pointer;
  }

  .user-info {
    height: 51px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px dashed #e2e2e2;
  }

  .logo-img {
    width: 155px;
    height: 24px;
  }
  .menu-container /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue